import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  NgxMatDatetimePickerModule,
  NgxMatTimepickerModule,
  NgxMatNativeDateModule,
} from '@angular-material-components/datetime-picker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RouterModule } from '@angular/router';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatDividerModule } from '@angular/material/divider';
import { MatSidenavModule } from '@angular/material/sidenav';
import { DialogModule } from 'src/@order/dialogs/dialog.module';
import { InterRegionalComponent } from './inter-regional.component';
import { ShareModuleModule } from 'src/@order/directive/share-module.module';
import { CommonComponentsModule } from 'src/@order/components/common-components.module';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatStepperModule } from '@angular/material/stepper';
import { InterRegionalPaymentSuccessComponent } from './inter-regional-payment-success/inter-regional-payment-success.component';
// import { PickupLocationsDialogComponent } from 'src/@order/dialogs/pickup-locations-dialog/pickup-locations-dialog.component';
@NgModule({
  declarations: [InterRegionalComponent, InterRegionalPaymentSuccessComponent],
  imports: [
    CommonModule,
    ShareModuleModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    FormsModule,
    MatDatepickerModule,
    RouterModule,
    CommonComponentsModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    MatDialogModule,
    MatRippleModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatIconModule,
    NgxMatNativeDateModule,
    MatInputModule,
    MatNativeDateModule,
    MatSelectModule,
    MatCheckboxModule,
    MatTabsModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatDividerModule,
    MatSidenavModule,
    DialogModule,
  ],
})
export class InterRegionalModule {}
